/**
* @file The list insight component
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { InsightBreeze } from '../insight-base/insight-breeze';
import { InsightProvider } from '../insight-provider';
import { InsightService } from '../../insights/insight.service';
import { LocalisationService } from '../../core/localisation.service';
import { ResourceService } from '../../resource.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
/**
 * Insight component that shows a List (horizontal Bar Chart).
 */
var InsightTableComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightTableComponent, _super);
    /**
     * Constructs an InsightListComponent
     * @param configurationsService A service that manages the configuration for components.
     * @param provider A provider that contains extra information such as configuration data.
     */
    function InsightTableComponent(resourceService, provider, insightService, localisationService, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.alertsService = alertsService;
        // Data object for insight table component
        _this.data = {
            items: []
        };
        return _this;
    }
    /**
     * Set the table insight data
     */
    InsightTableComponent.prototype.setData = function (items) {
        // If there are items set them or otherwise set state in nodata
        if (items.length > 0) {
            // Store data
            this.data['items'] = items;
            // Set ready
            this.setState('ready');
        }
        else {
            this.setState('nodata');
        }
    };
    return InsightTableComponent;
}(InsightBreeze));
export { InsightTableComponent };
